import {
  DebtRepaymentPlan,
  Disclaimer,
  Div,
  Pill,
  lightTheme,
} from '@vgrubs/components';
import { planMethods } from '../helpers/repaymentPlanLabels';

type Props = {
  plan: DebtRepaymentPlan;
};

/**
 * What a plan collects with, one chip per method, on the plan card and the
 * past plans. Chips rather than one joined sentence, which wrapped
 * mid-phrase. Flat grey pills, like the distance on a delivery row; a
 * shadowed box per method read as a stack of cards inside the card.
 */
export const PlanMethodChips = ({ plan }: Props) => (
  <Div $flex $gap="6px" $wrap>
    {planMethods(plan).map((method) => (
      <Pill key={method} $background={lightTheme.gray}>
        <Disclaimer $m="0" style={{ whiteSpace: 'nowrap' }}>
          {method}
        </Disclaimer>
      </Pill>
    ))}
  </Div>
);
